import { toast as sonnerToast } from "sonner";

type ToastVariant = 'default' | 'destructive' | 'success';

type ToastProps = {
  title?: string;
  description?: string;
  variant?: ToastVariant;
  duration?: number;
};

export function useToast() {
  const toast = (props: ToastProps) => {
    const { title, description, variant = 'default', duration = 3000 } = props;
    
    switch (variant) {
      case 'success':
        sonnerToast.success(title || '', {
          description,
          duration
        });
        break;
      case 'destructive':
        sonnerToast.error(title || '', {
          description,
          duration
        });
        break;
      default:
        sonnerToast(title || '', {
          description,
          duration
        });
        break;
    }
  };

  return { toast };
}